import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.SUPER_ADMIN };

const path = "admin/transaction"; // Assuming the base path from user's route snippet

export const getWalletHistory = async (values) => {
    return await axiosInstance(options).post(`${path}/wallet-list`, values);
};

export const getGatewayPaymentList = async (values) => {
    return await axiosInstance(options).post(`${path}/payment-list`, values);
};

export const getOrderPaymentList = async (values) => {
    return await axiosInstance(options).post(`${path}/order-list`, values);
};

export const getConsultationPaymentList = async (values) => {
    return await axiosInstance(options).post(`${path}/consultation-list`, values);
};

export const getTransactionDetails = async (values) => {
    return await axiosInstance(options).post(`${path}/details`, values);
};

export const getPaymentSummary = async (values) => {
    return await axiosInstance(options).post(`${path}/summary`, values);
};
